import { useState, useEffect, useRef } from 'react';
import { Modal } from '@/components/ui/Modal/Modal';
import { Button } from '@/components/ui/Button/Button';
import {
  SessionCancelReasonField,
  type SessionCancelReasonFieldHandle,
} from '@/components/SessionDialog/SessionCancelReasonField';
import { useToast } from '@/contexts/ToastContext';
import './SessionModal.css';

const NOTE_MAX = 300;

export interface SessionCancelReasonModalProps {
  open: boolean;
  onClose: () => void;
  /** Начальное значение (например при повторном редактировании причины) */
  initialNote?: string;
  onSave: (note: string) => Promise<void>;
}

export function SessionCancelReasonModal({ open, onClose, initialNote = '', onSave }: SessionCancelReasonModalProps) {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const fieldRef = useRef<SessionCancelReasonFieldHandle | null>(null);
  const { showError } = useToast();

  useEffect(() => {
    if (!open) return;
    setNote(initialNote.slice(0, NOTE_MAX));
  }, [open, initialNote]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!fieldRef.current?.validate()) {
      showError('Укажите причину');
      return;
    }
    setSaving(true);
    try {
      await onSave(note.trim().slice(0, NOTE_MAX));
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Причина отмены" headerVariant="island" size="sm">
      <form id="session-cancel-reason-form" onSubmit={handleSubmit} className="form session-modal__form">
        <div className="session-modal__form-body">
          <SessionCancelReasonField ref={fieldRef} value={note} onChange={setNote} showLabel={false} />
        </div>
        <div className="form__footer form__footer_modal">
          <Button variant="outlined" type="button" onClick={onClose} disabled={saving}>
            Отмена
          </Button>
          <Button type="submit" form="session-cancel-reason-form" variant="primary" disabled={saving}>
            {saving ? 'Сохранение…' : 'Сохранить'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
